import { createContext, useEffect, useState } from "react";
import EmptyBlockSecondary from "components/placeholder-blocks/EmptyBlockSecondary";
import Loader from "components/Loader";
import Pagination from "components/Pagination";
import { useOutletContext } from "react-router-dom";
import MainContentLeft from "components/main-components/MainContentLeft";
import PrizesList from "components/prizes/PrizesList";
import PageLoader from "components/page-components/PageLoader";
import useProfile from "hooks/useProfile";
import CombineFail from "components/combine/CombineFail";
import CombineList from "components/combine/CombineList";

export const PrizesContext = createContext();

const Prizes = () => {
  const {
    items,
    filters,
    isFiltersLoading,
    isItemsLoading,
    offsetCount,
    setOffsetCount,
    paginationData,
    getOpenedClass,
  } = useOutletContext();

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectMode, setSelectMode] = useState(false);
  const {errorText} = useProfile();


  if (!items.length && isFiltersLoading === true) {
    return <PageLoader />;
  }

  return (
    <PrizesContext.Provider
      value={{
        selectedItems,
        setSelectedItems,
        selectMode,
        setSelectMode,
      }}
    >
      <main className="main-content">
        <MainContentLeft
          getOpenedClass={getOpenedClass}
          filters={filters}
          setOffsetCount={setOffsetCount}
        />
        <div className="main-content__right">
          {isItemsLoading && !items.length ? (
            <Loader />
          ) : items.length ? (
            <>
              <CombineList items={items} />
              <Pagination
                offsetCount={offsetCount}
                setOffsetCount={setOffsetCount}
                paginationData={paginationData}
              />
            </>
          ) : (
            <EmptyBlockSecondary type={"prizes"} />
          )}
        </div>
      </main>

      {errorText !== null && <CombineFail errorText={errorText} />}
    </PrizesContext.Provider>
  );
};

export default Prizes;
